import { getToken } from "../Connector/Connector";
import { store } from "../index";
import { setAnnonymously } from "../reducers/stateManagmentReducer";
export const OpenUrl = (url) => {
  if (!sessionStorage.getItem("token") && window.location.search === "") {
    window.location.href = url;
  }
  if (window.location.search.includes("anonymous=Y")) {
    store.dispatch(setAnnonymously());
  }
  if (sessionStorage.getItem("token")) return;
  if (window.location.search.includes("accessToken")) {
    let params = window.location.search.split("&");
    let token = params[0];
    let refresh_token = params[1];
    sessionStorage.setItem("token", token.substring(13, token.length));
    sessionStorage.setItem("refresh_token", refresh_token.substring(13, refresh_token.length));
    window.location.href = "https://www.textunited.com/json-free-translator"; //"http://localhost:3000";
  } else {
    getToken().then((response) => {
      sessionStorage.setItem("refresh_token", response.data.refreshToken);
      sessionStorage.setItem("token", response.data.accessToken);
      store.dispatch(setAnnonymously());
      window.location.href = "https://www.textunited.com/json-free-translator"; //"http://localhost:3000";
    });
  }
};
